export enum ActionType {
  // UX State
  TOGGLE_KEY_FOCUS = "TOGGLE_KEY_FOCUS",
  INPUT_FOCUS_ON = "INPUT_FOCUS_ON",
  INPUT_FOCUS_OFF = "INPUT_FOCUS_OFF",
  SHOW_SHARE_MODAL = "SHOW_SHARE_MODAL",
  HIDE_SHARE_MODAL = "HIDE_SHARE_MODAL",
  SHOW_HELP_MODAL = "SHOW_HELP_MODAL",
  HIDE_HELP_MODAL = "HIDE_HELP_MODAL",
  TOGGLE_MUTE = "TOGGLE_MUTE",
  // sequence lines
  ADD_VCHORD = "ADD_VCHORD",
  UPDATE_VCHORD = "UPDATE_VCHORD",
  SET_CURRENT_CELL = "SET_CURRENT_CELL",
  DELETE_CURRENT_CELL = "DELETE_CURRENT_CELL",
  DELETE_GRID = "DELETE_GRID",
  // share
  SET_TITLE = "SET_TITLE",
  // player
  INC_BEAT = "INC_BEAT",
  TOGGLE_PLAY = "TOGGLE_PLAY",
  REWIND = "REWIND",
  SET_BPM = "SET_BPM",
}
